import script from "./SaleContractView.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleContractView.vue?vue&type=script&setup=true&lang=js"

import "./SaleContractView.vue?vue&type=style&index=0&id=895fc982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-895fc982"]])

export default __exports__